import React from "react";
import topicon from "../../../assets/top-icon.png";
import logo1 from "../../../assets/logo1.svg";
import logo from "../../../assets/logo.svg";
import ScamNotification from "../ScamNotification"
import ImportantNote from "../ImportantNote"
import SystemMaintenance from "../SystemMaintenance"
import { useConfig } from "../../../context/ConfigProvider";
export const LoginHeader: React.FC = () => {
  const cfg = useConfig();
  const UAT_AUTH_SCREEN = cfg.REACT_APP_UAT_AUTH_SCREEN;
  return (
    <header className="header">
      <div className="top-header">
           {/* Temp Message */}
        <SystemMaintenance />
        <div className="container">
        <p>
          <img src={topicon} alt="" className="img-fluid" /> A Singapore
            Government Agency Website <a className="btn btn-link govsg-btn" data-bs-toggle="collapse" href="#collapseGovsg" role="button" aria-expanded="false" aria-controls="collapseExample">
                        How to identify <span><i className="fas fa-chevron-down"></i></span>
                    </a>
          </p>
          <div className="collapse" id="collapseGovsg">
                    <div className="row justify-content-between govvia-style">
                        <div className="col-md-5">
                            <div className="d-flex me-3"><span>
                               <div className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" className="banner-icon">
                      <path d="M0.166016 5.6665V9.00067H0.999349V13.9998H0.166016V16.4998H0.999349H3.49935H5.16602H7.66601H9.33268H11.8327H13.4993L15.9993 16.5007V16.4998H16.8327V13.9998H15.9993V9.00067H16.8327V5.6665L8.49935 0.666504L0.166016 5.6665ZM3.49935 13.9998V9.00067H5.16602V13.9998H3.49935ZM7.66601 13.9998V9.00067H9.33268V13.9998H7.66601ZM13.4993 13.9998H11.8327V9.00067H13.4993V13.9998ZM10.166 5.6665C10.166 6.58651 9.41935 7.33317 8.49935 7.33317C7.57935 7.33317 6.83268 6.58651 6.83268 5.6665C6.83268 4.7465 7.57935 3.99984 8.49935 3.99984C9.41935 3.99984 10.166 4.7465 10.166 5.6665Z" fill="#242425"></path>
                    </svg>
                  </div>
                                </span>
                                <div className="ms-2">
                                    <h6 className="govsg-title">Official website links end with .gov.sg</h6>
                                    <p className="govsg-body">Government agencies communicate via <strong>.gov.sg </strong>websites <span className="avoidwrap">(e.g. go.gov.sg/open)</span>. <a href="https://go.gov.sg/trusted-sites" className="d-inline-block trusted-websites" target="_blank" rel="noreferrer" data-sf-ec-immutable="">Trusted websites <i className="fas fa-external-link-alt"></i></a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex me-3"><span><div className="icon d-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none" className="banner-icon">
                      <path d="M14.1663 9.00008C14.1663 8.08091 13.4188 7.33342 12.4997 7.33342H11.6663V4.83342C11.6663 2.53591 9.79717 0.666748 7.49967 0.666748C5.20217 0.666748 3.33301 2.53591 3.33301 4.83342V7.33342H2.49967C1.58051 7.33342 0.833008 8.08091 0.833008 9.00008V15.6667C0.833008 16.5859 1.58051 17.3334 2.49967 17.3334H12.4997C13.4188 17.3334 14.1663 16.5859 14.1663 15.6667V9.00008ZM4.99967 4.83342C4.99967 3.45508 6.12134 2.33341 7.49967 2.33341C8.87801 2.33341 9.99967 3.45508 9.99967 4.83342V7.33342H4.99967V4.83342Z" fill="#242425"></path>
                    </svg>
                  </div></span>
                                <div className="ms-2">
                                    <h6 className="govsg-title">Secure websites use HTTPS</h6>
                                    <p className="govsg-body">Look for a <strong>lock </strong>(<span className="icon d-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none" className="banner-icon">
                      <path d="M14.1663 9.00008C14.1663 8.08091 13.4188 7.33342 12.4997 7.33342H11.6663V4.83342C11.6663 2.53591 9.79717 0.666748 7.49967 0.666748C5.20217 0.666748 3.33301 2.53591 3.33301 4.83342V7.33342H2.49967C1.58051 7.33342 0.833008 8.08091 0.833008 9.00008V15.6667C0.833008 16.5859 1.58051 17.3334 2.49967 17.3334H12.4997C13.4188 17.3334 14.1663 16.5859 14.1663 15.6667V9.00008ZM4.99967 4.83342C4.99967 3.45508 6.12134 2.33341 7.49967 2.33341C8.87801 2.33341 9.99967 3.45508 9.99967 4.83342V7.33342H4.99967V4.83342Z" fill="#242425"></path>
                    </svg>
                  </span>) or https:// as an added precaution. Share sensitive information only on official, secure websites.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
         <ScamNotification />       
      </div>
      <div className="">
      <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container">
            <a className="navbar-brand" href="#">
              <img src={logo1} alt="NParks" className="img-fluid2" />
              <img src={logo} alt="AVS" className="img-fluid2" />
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
            </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-0 ms-lg-5">
                  <li className="nav-item">
                    <a className="nav-link" href="/eservices">
                      Home
                    </a>
                  </li>
                </ul>
            </div>
          </div>          
        </nav>
      </div>
    </header>
  );
};

export default LoginHeader;
